import type {
  FeatureCardCommonInterface,
  FeatureCardVariant,
} from "@/shared/components/FeatureCard";
import { DEFAULT_VARIANT } from "@/shared/components/FeatureCard";
import type { ImageDataType } from "@/shared/types";
import { BlockFeatureBlockFeatureItem } from "../directusTypes";
import { getImageData } from "./utils";

const resolveFeatureCardVariant = (
  variant: string | null | undefined,
  image: ImageDataType | null,
  symbol: string | null | undefined
): FeatureCardVariant => {
  if (variant === "no_icon") return "no_icon";

  const hasImage = Boolean(image);
  const hasSymbol = Boolean(symbol?.trim());

  if (variant === "with_image") {
    return hasImage ? "with_image" : hasSymbol ? "with_symbol" : "no_icon";
  }

  if (
    hasImage &&
    (variant === "outline_symbol" ||
      variant === "filled_symbol" ||
      variant === null ||
      variant === undefined)
  ) {
    return "with_image";
  }

  if (
    variant === "with_symbol" ||
    variant === "outline_symbol" ||
    variant === "filled_symbol" ||
    hasSymbol
  ) {
    return "with_symbol";
  }

  if (hasImage) return "with_image";

  return DEFAULT_VARIANT;
};

export const getFeatureItems = (
  items: BlockFeatureBlockFeatureItem[] | number[]
): FeatureCardCommonInterface[] => {
  return items
    .map((item) => {
      if (typeof item !== "object") return;
      const featureCard = item?.block_features_items_id;
      if (!featureCard || typeof featureCard !== "object") return;
      const { headline, description, variant, image, symbol } = featureCard;
      const imageData = getImageData(image);

      return {
        headline: headline ?? "",
        description: description ?? "",
        variant: resolveFeatureCardVariant(variant, imageData, symbol),
        image: imageData,
        symbol: symbol ?? "",
      };
    })
    .filter((item) => !!item);
};
